import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import { useGlobalGuard } from './guards/useGlobalGuard';
import { consumeOtlIfPresent } from './guards/useOtlConsumption';
import MixpanelService from '@/helpers/mixpanel/service';
import { PagesNamesEnum } from './pages.names.enum';
import { RoutingRouteEnum } from './routes.enum';
import { getRouteKeyFromRouteName, getRouteNameFromRouteKey } from '@/helpers/authorization/authorization';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import store from '@/store';
import { useWalletGuard } from './guards/wallet/useWalletGuard';

Vue.use(VueRouter);

const mixpanelService = new MixpanelService();
const { useGetters } = createNamespacedHelpers(store, 'authentication');

let otlConsumed = false;

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  // On first navigation, check for ?otl= and exchange it for a session
  // before the auth guard runs.
  if (!otlConsumed) {
    otlConsumed = true;
    await consumeOtlIfPresent();
  }
  useGlobalGuard(to, from, next);
});

router.afterEach((to, from) => {
  const { role } = useGetters(['role']);

  if (role.value == null) {
    const routeKey = getRouteKeyFromRouteName(to.name as RoutingRouteEnum);
    mixpanelService.track(`View ${getRouteNameFromRouteKey(routeKey as PagesNamesEnum)}`);
  }
});

router.afterEach((to, from) => {
  useWalletGuard(to, from);
});

router.onError((error) => {
  console.error(error);
  if (
    /ChunkLoadError:.*failed./i.test(error.message) ||
    /Loading.*chunk.*failed./i.test(error.message) ||
    /Loading.*CSS.*chunk.*failed/i.test(error.message)
  ) {
    window.location.reload();
  }
});

export default router;
